import { lazy, Suspense } from "react";
import { HOLY_WHEEL_SOURCE } from "../../../../../state/holyWheelSource";
import type { MainPageLaunchersProps } from "../MainPageLaunchers/MainPageLaunchers";
import { BackendMainPageLaunchers } from "../BackendMainPageLaunchers/BackendMainPageLaunchers";

const LocalHolyWheelLaunchers = import.meta.env.DEV
    ? lazy(() => import("../LocalHolyWheelLaunchers/LocalHolyWheelLaunchers"))
    : null;

export function MainPageLaunchersRuntime(
    props: Omit<MainPageLaunchersProps, "wheels">,
) {
    if (HOLY_WHEEL_SOURCE === "local" && LocalHolyWheelLaunchers) {
        return (
            <Suspense fallback={null}>
                <LocalHolyWheelLaunchers {...props} />
            </Suspense>
        );
    }
    return <BackendMainPageLaunchers {...props} />;
}
